import './styles';

import React from 'react';

import { formatNumberWithDelimiter } from 'shared/number_helper';
import LoadingMessage from 'details/components/loading_message';
import CategoriesChart from './categories_chart';

export default class CitingResearchCategoriesTab extends React.Component {
    render() {
        return (
            <div className="CitingResearchCategoriesTab">
                {this.props.publication.citationsLoaded ? (
                    this.content
                ) : (
                    <LoadingMessage text={I18n.t('research_categories_tab.loading')} />
                )}
            </div>
        );
    }

    get content() {
        if (this.props.publication.researchCategories.length) {
            return this.researchCategoriesData;
        } else {
            return this.noCitationsMessage;
        }
    }

    get noCitationsMessage() {
        return (
            <div className="CitingResearchCategoriesTab-empty-message">
                {I18n.t('research_categories_tab.no_categories')}
            </div>
        );
    }

    get researchCategoriesData() {
        return (
            <div className="CitingResearchCategoriesTab-content">
                {this.researchCategoriesSummary}
                <CategoriesChart categories={this.props.publication.researchCategories} />
            </div>
        );
    }

    get researchCategoriesSummary() {
        let count = this.props.publication.researchCategories.length;
        let formattedCount = formatNumberWithDelimiter(count);

        return (
            <div className="CitingResearchCategoriesTab-summary">
                <span className="count">
                    <span className="number">{formattedCount}</span>
                    <span className="text">{count == 1 ? 'category' : 'categories'}</span>
                </span>
                <span className="content">{I18n.htmlSafe('research_categories_tab.description')}</span>
                <span className="button">
                    <a href={this.props.publication.dimensionsURI} target="_blank">
                        {I18n.t('buttons.view_in_dimensions')}
                    </a>
                </span>
            </div>
        );
    }
}
